import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { TabListProps } from "../../Common/UI/Tabs/Tabs";
import { IRootState } from "../../../reducer/CombineReducer";
import { INavigation } from "../../RightPanel/ExtractDetail/ExtractNavigation/ExtractNavigation.logic";
import { MenuListType } from "../Redux/Types";

/**
 * Responsible for rendering the tab component with list based on the config
 * @param TabComponent incoming tab component
 * @returns the tab component with list
 */
export const TabListProvider = (TabComponent: React.FC<INavigation>): (props: INavigation) => JSX.Element => {
  const TabList = (props: INavigation): JSX.Element => {
    const appConfig = useSelector((state: IRootState) => state.appConfig);
    const { t: translate } = useTranslation();
    const tabList = appConfig?.tabList;
    const appKey = appConfig?.appKey;

    /**
     * To get the tablist from the config based on app key
     * @returns the tab list with area controls
     */
    const getTabsList = (): TabListProps[] => {
      const tabsListWithAreaControls: TabListProps[] = [];
      tabList.forEach((menuItem: MenuListType) => {
        if (menuItem.availableIn.includes(appKey)) {
          const detailTabName = menuItem.menuName;
          const customKey = detailTabName?.replace(/\s+/g, "-")?.toLowerCase();

          tabsListWithAreaControls.push({
            value: customKey,
            label: translate(`Tabs.${detailTabName}`),
          });
        }
      });

      return tabsListWithAreaControls;
    };

    return <TabComponent {...props} tabsList={getTabsList()} />;
  };

  return TabList;
};
